import React from 'react';
import { BadgeCheck } from 'lucide-react';

const VerifiedBadge: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span
    className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300 ${className}`}
    title="Doğrulanmış forum"
  >
    <BadgeCheck size={12} /> Doğrulandı
  </span>
);

export default VerifiedBadge;
